// TODO: Добавить типизацию
export const setPageTitle = () => document.title = 'Дом Икс';